<template>
    <div>
        <select class="form-control" v-model="activeDate" >
            <option v-for="rooms, date in presentations" :value="date">{{ $dayjs(date).format('dddd DD/MM') }}</option>
        </select>
        <hr>
        <div v-for="presentations, roomId in visiblePresentations" class="presentation-list">
            <h2>
                {{ presentations[0].room.name[_locale] }}
                <span v-if="presentations[0].room?.subname?.[_locale]" class="small text-nowrap">
                    ({{ presentations[0].room?.subname?.[_locale] }})
                </span>
            </h2>
            <presentation :presentation="presentation" :mobile="true" v-for="presentation in presentations" :key="presentation.id"></presentation>
        </div>
    </div>
</template>

<script>
export default {
    props: ['locale'],
    data() {
        return {
            presentations: null,
            activeDate: null,
        }
    },
    methods: {
        loadPresentations() {
            axios.get('/'+ this.locale +'/presentations')
                .then(response => {
                    this.presentations = response.data;

                    Vue.nextTick(() => {
                        this.setActiveDate();
                    })
                });
        },
        setActiveDate() {
            if (!this.presentations) {
                return;
            }

            let activeDate = localStorage.getItem('selected-presentation-date');

            if (!activeDate || (activeDate && (!this.presentations[activeDate] || !this.presentations[activeDate].length))) {
                    activeDate = Object.keys(this.presentations)[0];
            }

            this.activeDate = activeDate;
        },
    },
    computed: {
        visiblePresentations() {
            if (!this.activeDate) {
                return null;
            }
            if (!this.presentations) {
                return null;
            }

            let sortable = [];
            for (var roomId in this.presentations[this.activeDate]) {
                sortable.push(['room-'+ roomId, this.presentations[this.activeDate][roomId]]);
            }

            sortable.sort((a,b) => {
                return a[1][0].room.order_id < b[1][0].room.order_id ? -1 : 1;
            });

            let visiblePresentations = {};

            sortable.forEach(function(item){
                visiblePresentations[item[0]]=item[1];
            })

            return visiblePresentations;
        },
    },
    watch: {
        activeDate() {
            localStorage.setItem('selected-presentation-date', this.activeDate);
        }
    },
    mounted() {
        this.$dayjs.locale(this._locale);
        this.loadPresentations();
    }
}
</script>
